import get from 'lodash/get';
import identityConfig from '../../../../config/identity';

export default function gdprConsent(context) {
  const siteConfig = identityConfig;

  if (siteConfig === undefined) {
    return '';
  }
  const slug = get(context, 'staticPageData.slug');

  // todo: OR cookie policy
  if (slug === 'privacy-policy') {
    return `
    <!--  begin  consent  tag  -->
    <!--            your  client  engineer  will  help  you  construct  this  config  file Conversant  will  host  it  for  you  -->
    <!-- <script src="https://cdn.conversant.mgr.consensu.org/gdpr/cmp/config/f/a/fastcompany.com/config.js"></script>->
    <!--<script>
    //  code  to  suppress  tool  on  load
    window.cmpConfig.summon=false;
    </script> --> 
    <!--  begin  consent  code,  hosted  on  Conversant's  CDN  --> 
    <!--  <script src="https://secure-cdn.mplxtms.com/gdpr/cmp/gdpr-cmp-bootstrap.js"></script>->
    <script src="https://cdn.conversant.mgr.consensu.org/gdpr/cmp/gdpr-cmp-stub.js"></script>
    <script> var cnvr_launcher_options={lid:344} </script>
    <script src="https://secure.cdn.fastclick.net/js/cnvr-launcher/latest/launcher-stub.min.js"></script>
    <!--  end  consent  tag  -->


    `;
  }

  return `
    <!--  begin  consent  tag  -->
    <!--  your  client  engineer  will  help  you  construct  this  config  file Conversant  will  host  it  for  you  -->
    <!-- <script  src="https://cdn.conversant.mgr.consensu.org/gdpr/cmp/config/f/a/fastcompany.com/config.js"></script>-->
    <!--  uncomment  this  block  if  using  optional  functions
    <script>
    //use  callback  functions  to  create  TMS  trigger window.cmpConfig.callbacks.[See  Reference  Table  1]=   function(){
      //  begin  code  to  trigger  tag  re-firing
    }
    </script>
    -->
    <!-- begin  consent  code,  hosted  on  Conversant's  CDN  -->
    <!-- <script src="https://secure-cdn.mplxtms.com/gdpr/cmp/gdpr-cmp-bootstrap.js"></script>  -->
    <script src="https://cdn.conversant.mgr.consensu.org/gdpr/cmp/gdpr-cmp-stub.js"></script>
    <script> var cnvr_launcher_options={lid:344} </script>
    <script src="https://secure.cdn.fastclick.net/js/cnvr-launcher/latest/launcher-stub.min.js"></script>
    <!--  end  consent  tag  -->
  `;
}
